import { Context, getColumns, PricingTableHelper, getGridTemplateColumns, getRowsSortedByColumnOrder, getSectionHeader, getSectionSummary, } from '@getaccept/editor-lib-new';
import { defineComponent } from 'vue';
import PricingTableColumnHeaders from './PricingTableColumnHeaders.vue';
import PricingTableRow from './PricingTableRow.vue';
import PricingTableSectionSummary from './PricingTableSectionSummary.vue';
export default defineComponent({
    name: 'PricingTableSection',
    components: {
        PricingTableColumnHeaders,
        PricingTableRow,
        PricingTableSectionSummary,
    },
    props: {
        sections: { type: Array, default: () => [] },
        sectionId: { type: String, default: '' },
        currencySettings: {
            type: Object,
            default: () => ({}),
        },
        isPreCalculated: { type: Boolean },
        mergeValues: { type: Object, default: () => ({}) },
        fields: { type: Array, default: () => [] },
        context: { type: String, default: () => Context.DocumentView },
        isBlockWidthSmall: { type: Boolean },
        recipientInput: { type: Array, default: () => [] },
        recipient: { type: Object, default: () => ({}) },
        allowedToEditAfterPartiallySigned: { type: Boolean },
    },
    emits: ['update-input-value'],
    setup() {
        return {
            getEnabledColumns: PricingTableHelper.getEnabledColumns,
            getColumns,
            getGridTemplateColumns,
            getRowsSortedByColumnOrder,
            getSectionSummary,
            getSectionHeader,
        };
    },
});
